<template>
  <div class="container mx-auto px-4 pt-40 pb-32 max-w-4xl">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-8">
      Mon Compte
    </h1>

    <UTabs :items="items" class="w-full">
      <template #info>
        <div class="p-4">
          <ProfileInfo />
        </div>
      </template>

      <template #addresses>
        <div class="p-4">
          <ProfileAddresses />
        </div>
      </template>

      <template #payments>
        <div class="p-4">
          <ProfilePayments />
        </div>
      </template>

      <template #orders>
        <div class="p-4">
          <ProfileOrders />
        </div>
      </template>
    </UTabs>
  </div>
</template>

<script setup lang="ts">
// Nuxt auto-imports components from app/components usually.
// If not, we might need manual imports, but let's assume auto-import works for ProfileInfo etc.
// because they are in components/profile/ and Nuxt usually scans nested.
// If it fails, I'll add imports.

const items = [
  {
    slot: "info",
    label: "Informations",
    icon: "i-lucide-user",
  },
  {
    slot: "addresses",
    label: "Adresses",
    icon: "i-lucide-map-pin",
  },
  {
    slot: "payments",
    label: "Paiements",
    icon: "i-lucide-credit-card",
  },
  {
    slot: "orders",
    label: "Historique",
    icon: "i-lucide-history",
  },
];
</script>
